// Month-view calendar date picker — NEW feature (explicit ask in the rebuild brief): the
// original app only had prev/next single-day arrows for Nutrition and Workouts. This adds
// a real calendar so jumping to an arbitrary date doesn't take dozens of taps.
import { openModal, closeModal } from '../lib/modal.js';
import { today } from '../lib/dates.js';

const DOW = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
const MONTHS = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];

let state = { year: 0, month: 0, selected: null, onSelect: null, hasData: null };

export function openDatePicker(selectedDate, onSelect, hasDataFn) {
  const [y, m] = selectedDate.split('-').map(Number);
  state = { year: y, month: m - 1, selected: selectedDate, onSelect, hasData: hasDataFn || (() => false) };
  renderDatePicker();
  openModal('shDatePicker');
}

function shiftMonth(n) {
  state.month += n;
  if (state.month < 0) { state.month = 11; state.year--; }
  if (state.month > 11) { state.month = 0; state.year++; }
  renderDatePicker();
}
export function dpPrevMonth() { shiftMonth(-1); }
export function dpNextMonth() { shiftMonth(1); }

function pad(n) { return String(n).padStart(2, '0'); }

function renderDatePicker() {
  document.getElementById('dpTitle').textContent = `${MONTHS[state.month]} ${state.year}`;
  const first = new Date(state.year, state.month, 1);
  const startDow = (first.getDay() + 6) % 7; // Monday-first
  const daysInMonth = new Date(state.year, state.month + 1, 0).getDate();
  const daysInPrevMonth = new Date(state.year, state.month, 0).getDate();
  const td = today();

  let html = DOW.map(d => `<div class="dp-dow">${d}</div>`).join('');

  for (let i = 0; i < startDow; i++) {
    const d = daysInPrevMonth - startDow + i + 1;
    html += `<div class="dp-day other-month">${d}</div>`;
  }
  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${state.year}-${pad(state.month + 1)}-${pad(d)}`;
    const cls = ['dp-day'];
    if (dateStr === td) cls.push('today');
    if (dateStr === state.selected) cls.push('selected');
    if (state.hasData(dateStr)) cls.push('has-data');
    html += `<div class="${cls.join(' ')}" onclick="dpPick('${dateStr}')">${d}</div>`;
  }
  const totalCells = startDow + daysInMonth;
  const trailing = (7 - (totalCells % 7)) % 7;
  for (let d = 1; d <= trailing; d++) {
    html += `<div class="dp-day other-month">${d}</div>`;
  }
  document.getElementById('dpGrid').innerHTML = html;
}

export function dpPick(dateStr) {
  closeModal('shDatePicker');
  if (state.onSelect) state.onSelect(dateStr);
}
